import { createSurfaceElementClass } from "./surface-element.js";

export const EMBED_TAG_NAME = "akintu-embed";
export const INLINE_TAG_NAME = "akintu-inline";

/** Registers Embed once in the supplied document registry. */
export function registerEmbedElement(registry: CustomElementRegistry): void {
  if (registry.get(EMBED_TAG_NAME) !== undefined) return;
  registry.define(EMBED_TAG_NAME, createSurfaceElementClass("embed"));
}

/** Registers Inline once in the supplied document registry. */
export function registerInlineElement(registry: CustomElementRegistry): void {
  if (registry.get(INLINE_TAG_NAME) !== undefined) return;
  registry.define(INLINE_TAG_NAME, createSurfaceElementClass("inline"));
}
